<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">

            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button
                class="btn btn-sm btn-link"
                @click="$router.go(-1)"
              >
                <i class="fa fa-chevron-left"></i>
                {{ $t("message.back") }}
              </button>

              <h4 class="card-title">
                {{ $t("message.admin.admin_user_balance.operation_history") }}
              </h4>
            </div>

            <div class="card-body px-3">

              <div class="mb-3">
                <strong>
                  {{ $t("message.admin.admin_user_balance.user") }}:
                </strong>
                {{ org_name }}
              </div>

              <div class="row">
                <div class="col-12">

                  <hypertable
                    :show_pdf="false"
                    request="/admin/UsageReportUserOperations"
                    :additional_params="'&orgId=' + org_id"
                    :fields="fields"
                    :pagination_through_total_count="true"
                    :filter_date_empty_on_init="true"
                  />

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hypertable from "../hypertable.vue";

export default {
  name: "AdminUsageReportUserHistory",

  components: {
    hypertable,
  },

  data() {
    return {
      org_id: this.$route.params.org_id,
      org_name: this.$route.params.org_name,

      fields: [
          {
          key: "row_no",
          label: this.$t("message.admin.admin_user_balance.row_no"),
          sortable: false,
          summable: false,
        },
        {
          key: "action_date",
          label: this.$t(
            "message.admin.admin_user_balance.operation_date"
          ),
          sortable: true,
          summable: false,
        },
        {
          key: "action_type",
          label: this.$t(
            "message.admin.admin_user_balance.operation_type"
          ),
          sortable: false,
          summable: false,
          filterable: true,
          filter_options: [
            "пополнение",
            "списание"
          ]
        },
        {
          key: "amount",
          label: this.$t(
            "message.admin.admin_user_balance.amount"
          ),
          sortable: false,
          summable: false,
        },
        {
          key: "service_name",
          label: this.$t(
            "message.admin.admin_user_balance.service_name"
          ),
          sortable: false,
          summable: false,
        },
        {
          key: "search_keyword",
          label: this.$t(
            "message.admin.admin_user_balance.search_keyword"
          ),
          sortable: false,
          summable: false,
        },
        {
          key: "has_results",
          label: this.$t(
            "message.admin.admin_user_balance.has_results"
          ),
          sortable: false,
          summable: false,
          formatter: (value) => {
            return value
              ? this.$t("message.admin.admin_user_balance.yes")
              : this.$t("message.admin.admin_user_balance.no");
          },
        },
        {
          key: "is_api_request",
          label: this.$t(
            "message.admin.admin_user_balance.api_request"
          ),
          sortable: false,
          summable: false,
          formatter: (value) => {
            return value
              ? this.$t("message.admin.admin_user_balance.yes")
              : this.$t("message.admin.admin_user_balance.no");
          },
        }
      ],
    };
  },

  mounted() {
    if (!this.$store.state.auth) {
      this.$router.push({
        name: "sign-in",
      });
    }
  },
};
</script>

<style type="text/css">
.vs--single .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
</style>